// Events and Monitoring
export const EVENT_SET_CURRENT_FILTERS = 'EVENT_SET_CURRENT_FILTERS';
export const MONITORING_SET_CURRENT_PERIOD = 'MONITORING_SET_CURRENT_PERIOD';
export const MONITORING_SET_IS_NAVIGATION_OPEN = 'MONITORING_SET_IS_NAVIGATION_OPEN';
export const MONITORING_SET_IS_FORM_OPEN = 'MONITORING_SET_IS_FORM_OPEN';
export const MONITORING_SET_TOTAL_ANOMALY_DISPLAY_OPTIONS = 'MONITORING_SET_TOTAL_ANOMALY_DISPLAY_OPTIONS';
export const EVENT_PATCH = 'EVENT_PATCH';
export const EVENT_PATCH_SUCCESS = 'EVENT_PATCH_SUCCESS';
export const EVENT_PATCH_FAILURE = 'EVENT_PATCH_FAILURE';
export const EVENT_ALARM_PERIOD_ASSIGN = 'EVENT_ALARM_PERIOD_ASSIGN';
export const EVENT_ALARM_PERIOD_ASSIGN_SUCCESS = 'EVENT_ALARM_PERIOD_ASSIGN_SUCCESS';
export const EVENT_ALARM_PERIOD_ASSIGN_FAILURE = 'EVENT_ALARM_PERIOD_ASSIGN_FAILURE';
export const EVENT_ALARM_PERIOD_CREATE_EVENT = 'EVENT_ALARM_PERIOD_CREATE_EVENT';
export const EVENT_ALARM_PERIOD_CREATE_EVENT_SUCCESS = 'EVENT_ALARM_PERIOD_CREATE_EVENT_SUCCESS';
export const EVENT_ALARM_PERIOD_CREATE_EVENT_FAILURE = 'EVENT_ALARM_PERIOD_CREATE_EVENT_FAILURE';
export const EVENT_POST = 'EVENT_POST';
export const EVENT_POST_SUCCESS = 'EVENT_POST_SUCCESS';
export const EVENT_POST_FAILURE = 'EVENT_POST_FAILURE';
export const EVENT_CREATE = 'EVENT_CREATE';
export const EVENT_UPDATE_REFRESH_TIMESTAMP = 'EVENT_UPDATE_REFRESH_TIMESTAMP';
export const MONITORING_SET_TOOLTIP_DATA = 'MONITORING_SET_TOOLTIP_DATA';
export const MONITORING_ADD_TOOLTIP_PIN = 'MONITORING_ADD_TOOLTIP_PIN';
export const MONITORING_REMOVE_TOOLTIP_PIN = 'MONITORING_REMOVE_TOOLTIP_PIN';
// Event versions conflict
export const EVENT_VERSION_CONFLICT = 'EVENT_VERSION_CONFLICT';
export const EVENT_VERSION_CONFLICT_RETRIEVE_FAILURE = 'EVENT_VERSION_CONFLICT_RETRIEVE_FAILURE';
export const EVENT_VERSION_CONFLICT_RETRIEVE_SUCCESS = 'EVENT_VERSION_CONFLICT_RETRIEVE_SUCCESS';
export const EVENT_VERSION_CONFLICT_RESOLVED = 'EVENT_VERSION_CONFLICT_RESOLVED';
export const EVENT_VERSION_CONFLICT_CANCEL = 'EVENT_VERSION_CONFLICT_CANCEL';
// Hierarchy
export const RETRIEVE_HIERARCHY_ITEMS = 'RETRIEVE_HIERARCHY_ITEMS';
export const RETRIEVE_HIERARCHY_ITEMS_SUCCESS = 'RETRIEVE_HIERARCHY_ITEMS_SUCCESS';
export const RETRIEVE_HIERARCHY_ITEMS_FAILURE = 'RETRIEVE_HIERARCHY_ITEMS_FAILURE';
// WORKAROUND -- Active Model Entity definition on the server side
export const EXTEND_HIERARCHY_ITEMS = ' EXTEND_HIERARCHY_ITEMS';
export const RETRIEVE_HIERARCHY_ROOT = 'RETRIEVE_HIERARCHY_ROOT';
export const RETRIEVE_HIERARCHY_ROOT_SUCCESS = 'RETRIEVE_HIERARCHY_ROOT_SUCCESS';
export const RETRIEVE_HIERARCHY_ROOT_FAILURE = 'RETRIEVE_HIERARCHY_ROOT_FAILURE';
